module.exports = __webpack_public_path__ + "img/process-img-3.67d37ce7.png";